<template>
  <div :class="$style.editLesson">
    <div :class="$style.frameGroup">
      <div :class="$style.frameWrapper">
        <div :class="$style.curriculumTitleWrapper">
          <div :class="$style.titleText">Commercial Pilot 2024</div>
          <div>|</div>
          <b :class="$style.lessonTitle">Pilot Qualifications</b>
        </div>
      </div>
      <div :class="$style.backButton" @click="navigateBack">
        <img
          :class="$style.backIcon"
          alt=""
          src="/static/img/LeftChevron.svg"
        />
      </div>
    </div>
    <div :class="$style.frameDiv">
      <div :class="$style.lessonTitleWrapper">
        <b :class="$style.titleText">Pilot Qualifications</b>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Lesson Type</div>
        <div :class="$style.lessonTypeWrapper">
          <div :class="$style.titleText">Ground Instruction</div>
        </div>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Lesson Objective</div>
        <div :class="$style.descriptionWrapper">
          <div :class="$style.description">
            Students will understand the fundamental qualifications required to
            become a pilot, including educational, medical, and licensing
            requirements, and demonstrate the ability to outline the steps
            needed to achieve a pilot's license for their chosen aviation path
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.editLesson1">
      <div :class="$style.referenceMaterialWrapper">
        <b :class="$style.description">Reference Material</b>
      </div>
      <div :class="$style.lessonStandardsParent">
        <div :class="$style.lessonMaterialsWrapper">
          <div :class="$style.titleText">Lesson Materials</div>
        </div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">FAR 61.103</div>
        </div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">FAR 61.105</div>
        </div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">FAA Medical Certification Guide</div>
        </div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">
            Pilot Handbook of Aeronautical Knowledge - Chapter 15
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.frameDiv">
      <div :class="$style.lessonElementsWrapper">
        <b :class="$style.description">Lesson Elements</b>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Element 1</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Age, educational prerequisites, language proficiency, and medical
            standards for pilots.
          </div>
        </div>
        <div :class="$style.titleText">Standard</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Students will accurately identify and explain basic entry
            requirements.
          </div>
        </div>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Element 1</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Age, educational prerequisites, language proficiency, and medical
            standards for pilots.
          </div>
        </div>
        <div :class="$style.titleText">Standard</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Students will accurately identify and explain basic entry
            requirements.
          </div>
        </div>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Element 1</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Age, educational prerequisites, language proficiency, and medical
            standards for pilots.
          </div>
        </div>
        <div :class="$style.titleText">Standard</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Students will accurately identify and explain basic entry
            requirements.
          </div>
        </div>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Element 1</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Age, educational prerequisites, language proficiency, and medical
            standards for pilots.
          </div>
        </div>
        <div :class="$style.titleText">Standard</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Students will accurately identify and explain basic entry
            requirements.
          </div>
        </div>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.titleText">Element 1</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Age, educational prerequisites, language proficiency, and medical
            standards for pilots.
          </div>
        </div>
        <div :class="$style.titleText">Standard</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">
            Students will accurately identify and explain basic entry
            requirements.
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.editLesson1">
      <div :class="$style.referenceMaterialWrapper">
        <b :class="$style.description">Lesson Standards</b>
      </div>
      <div :class="$style.lessonStandardsParent">
        <div :class="$style.titleText">Lesson Standards</div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">
            Students should outline the general steps to earn a pilot's license
          </div>
        </div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">
            Students should understand the medical certification process
          </div>
        </div>
        <div :class="$style.referenceTitleWrapper">
          <div :class="$style.titleText">
            Students should demonstrate familiarity with FAA resources and
            regulatory guidelines
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.editLesson1">
      <div :class="$style.referenceMaterialWrapper">
        <b :class="$style.description">Create Assignments</b>
      </div>
      <div :class="$style.lessonStandardsParent">
        <div :class="$style.titleText">Lesson Assignements</div>
        <div :class="$style.lessonTitleParent">
          <div :class="$style.titleText">Pilot Qualifications</div>
          <img
            :class="$style.frameItem"
            alt=""
            src="/static/img/grey-paper-airplane.svg"
          />
        </div>
      </div>
    </div>
    <div :class="$style.editLesson1">
      <div :class="$style.referenceMaterialWrapper">
        <b :class="$style.description">Regulatory Requirements</b>
      </div>
      <div :class="$style.lessonStandardsParent">
        <div :class="$style.titleText">Regulations</div>
        <div :class="$style.regulationTitleWrapper">
          <div :class="$style.description">
            FAR 61.105(b)(1) - Applicaable feberal aviation regulations of this
            chapter that relate to private pilot priveleges, limitations, and
            flight operations.
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.frameDiv">
      <div :class="$style.lessonElementsWrapper">
        <b :class="$style.description">Completion Status</b>
      </div>
      <div :class="$style.lessonTypeParent">
        <div :class="$style.notesWrapper">
          <div :class="$style.titleText">Notes</div>
        </div>
        <div :class="$style.notesContainer">
          <div :class="$style.titleText">Notes...</div>
        </div>
      </div>
      <div :class="$style.taughtByParent">
        <div :class="$style.lessonTitle">Taught by</div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">Matthew Benesik</div>
        </div>
        <div :class="$style.elementTitleWrapper">
          <div :class="$style.titleText">425635CFI</div>
        </div>
      </div>
      <div :class="$style.attendanceParent">
        <div :class="$style.attendance">Attendance</div>
        <div :class="$style.selectAllParent">
          <div :class="$style.titleText">Select all...</div>
          <img :class="$style.icon1" alt="" src="/static/img/DownChevron.svg" />
        </div>
        <div :class="$style.selectAllParent">
          <div :class="$style.titleText">Date</div>
          <img
            :class="$style.frameItem"
            alt=""
            src="/static/img/Calendar.svg"
          />
        </div>
      </div>
      <div :class="$style.signingInstructorParent">
        <div :class="$style.description">Signing Instructor</div>
        <div :class="$style.clickToSignWrapper">
          <div :class="$style.titleText">Click to Sign</div>
        </div>
        <div :class="$style.wrapper">
          <div :class="$style.titleText">03/17/2025</div>
        </div>
      </div>
    </div>
    <div :class="$style.frameWrapper1">
      <div :class="$style.saveLessonWrapper" @click="onSave">
        <b :class="$style.titleText">Save Lesson</b>
      </div>
    </div>
    <div :class="$style.frameChild1" />
  </div>
</template>
<script>
export default {
  name: "EditLesson",
  methods: {
    navigateBack() {
      this.$router.go(-1);
    },
    onSave() {
      this.navigateBack();
    },
  },
};
</script>
<style module scoped>
.frameChild {
  align-self: stretch;
  width: 1px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.lessonTitle {
  position: relative;
  color: #404040;
}
.curriculumTitleWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.frameWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  z-index: 0;
}
.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
}
.backButton {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  z-index: 1;
}
.frameGroup {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  position: relative;
  gap: 20px;
  font-size: 25px;
  color: rgba(64, 64, 64, 0.5);
}
.icon {
  width: 24px;
  position: relative;
  height: 23px;
}
.titleText {
  position: relative;
}
.iconParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.getStartedWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 15px;
  font-size: 15px;
  color: #d701ff;
}
.frameContainer {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background: linear-gradient(90deg, #2200ff, #ea00ff);
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
}
.lessonTitleWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 40px;
}
.lessonTypeWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  color: #707070;
}
.lessonTypeParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.description {
  flex: 1;
  position: relative;
}
.descriptionWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 20px;
  color: rgba(64, 64, 64, 0.75);
}
.frameDiv {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
  font-size: 15px;
}
.referenceMaterialWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.lessonMaterialsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 5px;
}
.referenceTitleWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
}
.editLesson1 {
  width: 900px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
}
.lessonElementsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
.elementTitleWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
}
.lessonStandardsParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
}
.frameItem {
  width: 30px;
  position: relative;
  height: 30px;
}
.lessonTitleParent {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  color: rgba(64, 64, 64, 0.75);
}
.regulationTitleWrapper {
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 20px;
  color: rgba(64, 64, 64, 0.75);
}
.notesWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.notesContainer {
  align-self: stretch;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 20px;
  color: rgba(64, 64, 64, 0.5);
}
.taughtByParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  color: rgba(64, 64, 64, 0.75);
}
.attendance {
  flex: 1;
  position: relative;
  color: #404040;
}
.icon1 {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}
.selectAllParent {
  flex: 0.8226;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
}
.attendanceParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: rgba(64, 64, 64, 0.5);
}
.clickToSignWrapper {
  flex: 0.831;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.15);
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  box-sizing: border-box;
}
.wrapper {
  flex: 0.8226;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  color: rgba(64, 64, 64, 0.5);
}
.signingInstructorParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.saveLessonWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.frameWrapper1 {
  width: 900px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 18px;
  color: #fff;
}
.frameChild1 {
  width: 100px;
  position: relative;
  background-color: #f6f6f6;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
}
.editLesson {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 25px 0px 0px;
  box-sizing: border-box;
  gap: 25px;
  text-align: left;
  font-size: 22px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
